export class RequestLog {
    private _url: string;
    private _method: string;
    private _requestBody: any;
    private _responseCode: number;
    private _responseBody: any;

    constructor(url: string, method: string, requestBody: any, responseCode: number, responseBody: any) {
        this._url = url;
        this._method = method;
        this._requestBody = requestBody;
        this._responseCode = responseCode;
        this._responseBody = responseBody;
    }

    get url(): string {
        return this._url;
    }

    get method(): string {
        return this._method;
    }

    get requestBody(): any {
        return this._requestBody;
    }

    get responseCode(): number {
        return this._responseCode;
    }

    get responseBody(): any {
        return this._responseBody;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/requestlog.model.ts